import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
    new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
    new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction de recherche de tiers
async function searchTiers(nom){
    try {
        const response = await requestApi({
            method: 'GET',
            url: '/api/getThirdparties',
            params: {nom: nom},
            form: {},
            headers: {'Content-Type': 'application/json'}
        });
        let thirdparties = [];
        response.forEach(element => {
            thirdparties.push({
                value: element.id,
                label: element.name,
                tiers: element
            });
        });
        this.tiers = thirdparties;
    } catch (error) {
        if(error.response != undefined){
            toasterError(`Pas de tiers existants`,'Recherche Tiers');
            this.tiers = [];
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible');
            this.tiers = [];
        }
    }
}

//Fonction de récupération des contacts
async function getContacts(id){
    try {
        const response = await requestApi({
            method: 'GET',
            url: '/api/loadingContacts',
            params: {id: id},
            form: {},
            headers: {'Content-Type': 'application/json'}
        });
        this.formContrat.siege.contact = response[0].firstname + ' ' + response[0].lastname;
        this.formContrat.siege.fonction = response[0].poste;
        this.formContrat.siege.courriel = response[0].mail;
        if(response[0].phone_mobile){
            this.formContrat.siege.telephone = response[0].phone_mobile;
        }else if(response[0].phone_perso){
            this.formContrat.siege.telephone = response[0].phone_perso;
        }else{
            this.formContrat.siege.telephone = response[0].phone_pro;
        }
    } catch (error) {
        if(error.response != undefined){
            toasterError(`Aucun contact dans cette société`,'Récupération des contacts');
            this.tiers = [];
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible');
            this.tiers = [];
        }
    }
}

// Fonction appel api
function requestApi (options) {
    return new Promise((resolve, reject) => {
        new Vue().axios({
            method: options.method,
            url: conf.server + options.url,
            params: options.params,
            data: options.form,
            headers: options.headers,
            withCredentials: true
        }).then((response) => {
            resolve(response.data)
        }).catch((error) => {
            reject(error)
        })
    })
}

export default{
    searchTiers,
    getContacts,
    toasterError,
  	toasterSuccess,
}

